module.exports = __webpack_public_path__ + "static/media/user-alt-slash.f35696ba.svg";